import { render, staticRenderFns } from "./Telephones.vue?vue&type=template&id=438f847f&web=true&"
import script from "./Telephones.vue?vue&type=script&lang=js&"
export * from "./Telephones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports